<template>
  <div class="wrapper header">
    <!-- <div
      class="suspension"
      @mouseover="suspensionMouseOver"
      @mouseleave="suspensionMouseLeave"
      v-if="isSuspension"
    >
      <a
        :href="suspensionContent[0].linkUrl"
        target="_blank"
        v-if="suspensionContent.length > 0"
      >
        <img
          :src="$store.store.state.windonsrc + suspensionContent[0].imgBase64"
          style="width: 100%; height: 100%"
        />
      </a>
      <div class="suspension_close" @click="isSuspension = false">
        <i class="el-icon-close"></i>
      </div>
    </div> -->
    <!-- <img
      ref="bannerHeight"
      :src="$store.store.state.windonsrc + '28fcb60c32234cea97a4.jpg'"
      style="width: 100%; height: 260px"
      @load="imgLoad"
    /> -->
    <!-- {{ $store.store.state.windonsrc + item.imgBase64 }} -->
    <!-- {{ bannerList }} -->
    <div class="wrapper block">
      <el-carousel trigger="click" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <a @click="goBlank(item.linkUrl)" target="_blank" v-if="item.linkUrl">
            <img
              ref="bannerHeight"
              :src="$store.store.state.windonsrc + item.imgBase64"
              style="width: 100%; height: 260px"
              @load="imgLoad"
            />
          </a>
          <img
            v-else
            ref="bannerHeight"
            :src="$store.store.state.windonsrc + item.imgBase64"
            style="width: 100%; height: 260px"
            @load="imgLoad"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="headerWrapper" style="position: fixed; top: 40%; left: 98%">
      <div class="header_top">
        <!-- <a href="#" class="logo"
          ><img src="../../static/images/common/logo.png" style="width: 300px"
        /></a> -->
        <div class="header_top_right">
          <!-- <el-tooltip
            placement="bottom"
            effect="light"
            class="header_tooltip"
            width="148"
          >
            <div slot="content">
              <div class="header_tooltip_erweima">
                <img
                  src="../../static/images/common/erweima.png"
                  style="width: 100%; height: 100%"
                />
              </div>
              <p class="header_tooltip_text">扫一扫</p>
              <p class="header_tooltip_text">关注实时信息</p>
            </div>
            <div class="header_top_right_in">
              <i
                class="sinaIcon"
                style="position: absolute; top: -16px; left: -2px"
              ></i>
              <div style="width: 10px">新浪微博</div>
            </div>
          </el-tooltip> -->
          <el-tooltip
            style="margin-top: 50px"
            placement="bottom"
            effect="light"
            class="header_tooltip"
            width="148"
            v-if="wximg"
          >
            <div slot="content">
              <div class="header_tooltip_erweima">
                <img
                  v-if="wximg"
                  :src="$store.store.state.windonsrc + wximg"
                  style="width: 100%; height: auto"
                />
              </div>
              <p class="header_tooltip_text">扫一扫</p>
              <p class="header_tooltip_text">关注实时信息</p>
            </div>
            <div class="header_top_right_in">
              <i
                class="weixinIcon"
                style="position: absolute; top: 20%; left: -2px"
              ></i>
              <div style="width: 10px">微信公众号</div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="wrapper nav">
      <div class="flex contentwidth1">
        <ul class="active">
          <div class="nav_main" v-for="(item, index) in menuList" :key="index">
            <el-dropdown
              class="menu_dropdown"
              placement="bottom"
              style="width: 100%"
            >
              <router-link
                :to="item.url"
                @click.native="check(item.menu, index)"
                :class="{ active: ind == index }"
                exact
              >
                <li>
                  <div>{{ item.menu }}</div>
                  <div class="nav_border"></div>
                </li>
              </router-link>
              <el-dropdown-menu
                slot="dropdown"
                v-if="item.children.length > 0"
                :class="
                  item.menu == '党建工作' ||
                  item.menu == '科普公益' ||
                  item.menu == '教育培训'
                    ? 'dropdown_center'
                    : ''
                "
              >
                <el-dropdown-item
                  v-for="(childrenItem, childrenIndex) in item.children"
                  :key="childrenIndex"
                  :command="childrenItem"
                >
                  <router-link
                    :to="childrenItem.url"
                    @click.native="check2(index)"
                    style="width: 100%; height: 100%"
                    exact
                  >
                    {{ childrenItem.name }}</router-link
                  >
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { contactUs } from "@/request/api";
import {
  getmenu,
  bannerQuery,
  linkQuery,
  handleGuide,
  meetingnotice,
} from "@/request/api";
import img from "@/view/center/img.vue";
export default {
  name: "HelloWorld",
  components: { img },
  data() {
    return {
      activeNameNotice: 0,
      bannerList: [], //banner图
      newsList: [
        { menuName: "通知公告", id: "5_1", newsContent: [], totalCountVal: "" },
        { menuName: "新闻动态", id: "3_1", newsContent: [], totalCountVal: "" },
        { menuName: "政策法规", id: "4_1", newsContent: [], totalCountVal: "" },
      ], //新闻资讯tab列表
      policyList: [], //政策法规列表
      policyContent: [], //政策法规列表-内容
      policyIndex: 0,
      clinicalCenter: "", //中心介绍-临床试验中心
      relatedLinksList: [], //相关链接
      educationList: [], //教育培训
      suspensionContent: "",
      isSuspension: true,
      timer: "",
      sxVal: 0,
      syVal: 0,
      dropdownWidth:'157px',
      bannerHeight: "",
      searchInput: "",
      wximg: "",
      ind: 0,
      parentMenuId: "",
      menuList: [
        { menu: "首页", url: "/", path: "/", children: [] },
        {
          menu: "机构介绍",
          url: "/center?id=2_1&index=0",
          path: "/center",
          children: [
            { name: "机构简介", url: "/center?id=2_1&index=0" },
            { name: "专业介绍", url: "/center?id=2_2&index=1" },
            { name: "专家简介", url: "/center?id=2_6&index=2" },
            // { name: "荣誉主任委员简介", url: "/center", id: "2_4", index: 3 },
            // { name: "工作组介绍", url: "/center", id: "2_5", index: 4 },
          ],
        },
        {
          menu: "新闻动态",
          url: "/party",
          path: "/party",
          children: [
            { name: "新闻动态", url: "/party/partyContent?id=3_1&index=0" },
            // { name: "公告通知", url: "/party/partyContent?id=3_2&index=1" },
            // { name: "系列讲话", url: "/party/partyContent?id=3_3&index=2" },
            // { name: "活动集锦", url: "/party/partyContent?id=3_4&index=3" },
          ],
        },
        {
          menu: "办事指南",
          url: "/handleguide?id=13_1&index=0",
          path: "/handleguide",
          children: [],
        },
        {
          menu: "政策法规",
          url: "/enchiridion?id=4_1&index=0",
          path: "/enchiridion",
          children: [
            // {
            //   name: "药监局政策法规",
            //   url: "/enchiridion",
            //   id: "4_1",
            //   index: 0,
            // },
            // {
            //   name: "卫健委政策法规",
            //   url: "/enchiridion",
            //   id: "4_2",
            //   index: 1,
            // },
            // {
            //   name: "国际政策法规及其他",
            //   url: "/enchiridion",
            //   id: "4_3",
            //   index: 2,
            // },
          ],
        },
        { menu: "通知公告", url: "/learn", path: "/learn", children: [] },
        { menu: "志愿者招募", url: "/recruit", path: "/recruit", children: [] },
        { menu: "建言献策", url: "/propose", path: "/propose", children: [] },
        {
          menu: "联系我们",
          url: "/contactUs",
          path: "/contactUs",
          children: [],
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      console.log(222222222);
      console.log(to.path);
      console.log(from);
      let path = to.path.split("?")[0];
      console.log(path);
      for (var i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].path == to.path) {
          this.ind = i;
        } else if (path == "/party/partyContent") {
          this.ind = 2;
        }
      }
    },
  },
  created() {
    this.bannerQuery_Fun(1, "1_1"); //banner图
    // this.linkQuery_Fun("11_1", 1); //链接管理-相关链接
    // this.suspension();
    this.getmenu_Fun();
    if (window.sessionStorage.getItem("menuIndex")) {
      this.ind = window.sessionStorage.getItem("menuIndex");
    } else {
      this.ind = 0;
    }
  },
  mounted() {
    let params = {
      blongToMenu: "10_1",
      pageSize: 100,
      pageNumber: 1,
    };
    contactUs(params).then((res) => {
      console.log(res);
      if (res.data.code == 200) {
        this.wximg = res.data.data.list[0].wechat;
      }
      console.log(this.wximg);
    });
    // this.$nextTick(() => {
    //   //元素加载完成后执行的代码
    //   setTimeout(() => {
    //     this.suspension();
    //   }, 500);
    // });
    // this.getmap()
  },
  methods: {
    getPash() {
      console.log(this.$route.query);
      return "/party";
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
        console.log(
          "this.$refs.bannerHeight[0].height",
          this.$refs.bannerHeight[0].height
        );
      });
    },
    goMore(index) {
      console.log(index);
      if (index == 0) {
        this.$router.push({
          path: "/learn",
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/meeting",
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/welfare",
        });
      }
    },

    getmenu_Fun(parentMenuId) {
      let params = {
        parentMenuId: parentMenuId,
        pageSize: 100,
        pageNumber: 1,
      };
      getmenu(params)
        .then((res) => {
          console.log(res);
          console.log(parentMenuId);
          if (res.data.code == 200) {
            if (parentMenuId == 4) {
              //政策法规
              this.policyList = res.data.data.list;
              this.handleGuide_Fun(4, res.data.data.list[0].id, 6, 0);
              console.log(this.policyList);
            }
          }
        })
        .catch((err) => {});
    },
    bannerQuery_Fun(type, blongToMenu) {
      let params = {};
      if (type == 1) {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 10,
          pageNumber: 1,
          type: type,
        };
      } else {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 1,
          pageNumber: 1,
        };
      }
      bannerQuery(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (type == 1) {
              this.bannerList = res.data.data.list;
            } else if (type == 2) {
              this.clinicalCenter = res.data.data.list[0];
            }
          }
        })
        .catch((err) => {});
    },
    linkQuery_Fun(blongToMenu, type) {
      // 相关链接
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 100,
        pageNumber: 1,
        type: type,
      };
      linkQuery(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (type == 1) {
              // 相关链接
              this.relatedLinksList = res.data.data.list;
            } else if (type == 2) {
              this.suspensionContent = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },

    noticeClick(tab, event) {
      console.log(tab, event);
      if (tab.index == 0) {
        this.handleGuide_Fun(5, this.newsList[tab.index].id, 5, tab.index);
      } else if (tab.index == 1) {
        this.handleGuide_Fun(6, this.newsList[tab.index].id, 5, tab.index);
      } else {
        this.handleGuide_Fun(7, this.newsList[tab.index].id, 5, tab.index);
      }
    },
    goBlank(url){
      if (url.indexOf('www')!=-1) {
        window.open('http://'+url,'_blank')
      }else{
        window.open(url,'_blank')
      }
    },
    meetingnotice_Fun(num, blongToMenu, pageSize, index) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: pageSize,
        pageNumber: 1,
      };
      meetingnotice(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.newsList[index].newsContent = res.data.data.list;
            this.newsList[index].totalCountVal = res.data.data.totalCount;
            // this.$set(this.newsList, index, this.newsList[index]);
          }
        })
        .catch((err) => {});
    },
    policyClick(index) {
      this.policyIndex = index;
      console.log(this.policyList[index].id);
      this.handleGuide_Fun(4, this.policyList[index].id, 6, index);
    },
    handleGuide_Fun(num, blongToMenu, pageSize, index) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: pageSize,
        pageNumber: 1,
      };
      handleGuide(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (num == 5 || num == 6 || num == 7) {
              this.newsList[index].newsContent = res.data.data.list;
              this.newsList[index].totalCountVal = res.data.data.totalCount;
              // this.$set(this.newsList, index, this.newsList[index]);
            } else if (num == 8) {
              this.educationList = res.data.data.list;
            } else if (num == 4) {
              this.policyContent = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    lookMore(url) {
      this.$router.push({ path: url });
    },
  },
  beforeDestroy() {
    console.log(55555555555);
    window.clearInterval(this.timer);
  },
  check(menu, index) {
    console.log(1);
    this.ind = index;
    window.sessionStorage.setItem("menuIndex", index);
  },
  check2(index) {
    console.log(2);
    this.ind = index;
    window.sessionStorage.setItem("menuIndex", index);
  },
  goCommand(command) {
    console.log(command);
    this.$router.push({
      path: command.url,
      query: {
        id: command.id,
        index: command.index,
      },
    });
  },
  getmap() {
    let params = {
      blongToMenu: "10_1",
      pageSize: 100,
      pageNumber: 1,
    };
    contactUs(params).then((res) => {
      console.log(res);
      if (res.data.code == 200) {
        this.wximg = res.data.data.list[0].wechat;
      }
    });
  },
  getmenu_Fun() {
    let params = {
      parentMenuId: 2,
      pageSize: 100,
      pageNumber: 1,
    };
    getmenu(params)
      .then((res) => {
        console.log("11111111111111");
        console.log(res.data.data.list);
        if (res.data.code == 200) {
          let data = res.data.data.list;
          var array = [];
          data.forEach((element, index) => {
            array.push({
              name: element.menuName,
              url: "/center",
              id: element.id,
              index: index,
            });
          });
          console.log("12222222222222");
          console.log(array);
          console.log(this.menuList);
          this.menuList[1].children = array;
        }
      })
      .catch(() => {});

    //

    let params2 = {
      parentMenuId: 4,
      pageSize: 100,
      pageNumber: 1,
    };
    getmenu(params2)
      .then((res) => {
        console.log("11111111111111");
        console.log(res.data.data.list);
        if (res.data.code == 200) {
          let data = res.data.data.list;
          var array = [];
          data.forEach((element, index) => {
            array.push({
              name: element.menuName,
              url: "/enchiridion",
              id: element.id,
              index: index,
            });
          });
          console.log("12222222222222");
          console.log(array);
          console.log(this.menuList);
          this.menuList[3].children = array;
        }
      })
      .catch(() => {});
  },
};
</script>

<style>
.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0px 0px 6px 0px rgba(43, 70, 67, 0.32) !important;
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ddeeed !important;
}
.el-dropdown-menu {
  width: 157px !important;
  background-color: #018277 !important;
  border: none !important;
  box-shadow: 0px 0px 6px 0px rgba(1, 130, 119, 0.32) !important;
}
.dropdown_center.el-dropdown-menu {
  width: 120px !important;
}
.el-dropdown-menu a {
  width: 100% !important;
  display: block !important;
  color: #fff !important;
}
.el-dropdown-menu__item {
  color: #fff !important;
  width: 100% !important;
  text-align: left !important;
  padding: 0 25px !important;
  box-sizing: border-box !important ;
}
.dropdown_center .el-dropdown-menu__item {
  text-align: center !important;
}
.el-popper[x-placement^="bottom"] .el-dropdown-menu__item:hover,
.el-dropdown-menu__item a:hover {
  color: #018277 !important;
  background-color: #fff !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow,
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: transparent !important;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 4px !important;
}
</style>
<style scoped>
.header_top {
  height: 100px;
  justify-content: space-between;
  align-items: center;
}
.header_search {
  width: 350px;
  height: 30px;
}
.logo {
  /* width: 572px;
  height: 119px; */
  display: block;
  /* background: url(../../static/images/common/logo.png) no-repeat; */
  background-size: cover;
  margin-left: -10px;
}
.header_top_right {
  height: 20px;
  align-items: center;
}
.header_top_right_in {
  margin-right: 27px;
  font-size: 14px;
  color: #808080;
  /* display: flex; */
  align-items: center;
  cursor: pointer;
}
.header_top_right_in:last-child {
  margin-right: 0;
}
.header_top_right_in i {
  margin-right: 5px;
}
.header_tooltip_erweima {
  width: 102px;
  height: 102px;
  margin: 0 auto 3px;
}
.header_tooltip_text {
  text-align: center;
  font-size: 12px;
  color: #018277;
  line-height: 18px;
}
.nav {
  height: 60px;
  background-color: #018277;
}
.nav ul {
  display: flex;
  list-style-type: none;
}
.nav ul li {
  min-width: 103px;
  text-align: center;
  height: 56px;
  position: relative;
  line-height: 56px;
  padding: 0 27px;
}
.nav ul a,
.nav ul .menu_dropdown a {
  font-size: 16px;
  color: #fff;
  text-decoration: none;
}
.nav_border {
  width: 1px;
  height: 15px;
  position: absolute;
  top: 23px;
  right: 0;
  background-color: #3ea098;
}
.nav ul .nav_main:last-child a li .nav_border {
  display: none;
}
.nav ul .active li {
  background-color: #047168;
  font-weight: bold;
  border-bottom: solid 4px #e3c313;
}
#footerPage {
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  height: 60px;
  bottom: 0px;
  width: 100%;
  margin-top: 100px;
  font-size: 12px;
  color: #fff;
  padding-top: 20px;
}
.bannner {
  width: 100%;
  height: 200px;
  background: #1977df;
  opacity: 0.5;
  color: #fff;
  text-align: center;
  line-height: 200px;
  font-size: 20px;
}
.return {
  height: 36px;
  background-color: #0387a8;
  border-radius: 4px;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.returnIcon {
  width: 16px;
  height: 16px;
  background: url("../../static/images/common/returnIcon.png");
  margin-right: 5px;
  background-size: cover;
}
.return_text {
  font-size: 18px;
  color: #fff;
  line-height: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue